import script from "./SitiWebAvvocati.vue?vue&type=script&setup=true&lang=js"
export * from "./SitiWebAvvocati.vue?vue&type=script&setup=true&lang=js"

import "./SitiWebAvvocati.vue?vue&type=style&index=0&id=f2edf12e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2edf12e"]])

export default __exports__